import { Link, useLocation } from 'react-router-dom'
import { cn } from '@/lib/utils'
import {
  LayoutDashboard,
  Settings,
  MessagesSquare,
  HelpCircle,
  BarChart,
  Plug,
} from 'lucide-react'

interface DashboardNavProps {
  onNavClick?: () => void
}

const navItems = [
  {
    title: 'Dashboard',
    href: '/dashboard',
    icon: LayoutDashboard,
  },
  {
    title: 'Assistants',
    href: '/dashboard/assistants',
    icon: MessagesSquare,
  },
  {
    title: 'Reports',
    href: '/dashboard/reports',
    icon: BarChart,
  },
  {
    title: 'Integrations',
    href: '/dashboard/integrations',
    icon: Plug,
  },
  {
    title: 'Settings',
    href: '/dashboard/settings',
    icon: Settings,
  },
  {
    title: 'Help',
    href: '/help',
    icon: HelpCircle,
  },
]

export function DashboardNav({ onNavClick }: DashboardNavProps) {
  const location = useLocation()

  return (
    <nav className="grid gap-1 px-2">
      {navItems.map((item) => (
        <Link
          key={item.href}
          to={item.href}
          onClick={onNavClick}
          className={cn(
            'menu-item',
            location.pathname === item.href && 'active'
          )}
        >
          <item.icon className="menu-item-icon" />
          <span>{item.title}</span>
        </Link>
      ))}
    </nav>
  )
}

